import styled from 'styled-components';


export const StyledChart = styled.div`

`;



// WEBPACK FOOTER //
// ./src/common/Chart/styles/StyledChart.js